<div id="container">
    <img src="../../../assets/comment.png" alt="dp" width="15px" height="15px" id="img">
    <div id="text">25</div>
</div>

